import React, { useContext } from 'react'
import { PlayerProfileContext } from '../../../../Context'
import { Section } from './styles'
import { createPlayerShopUTM } from '../../../../Routing'
import { LinkBtn } from '../../../../Components/Buttons/LinkBtn'
import { Img } from '../../../../Components/Image/Img'
import { getTeamJerseyData } from '../../../../Utils'
import { Head2 } from '../../../../Components/Typography/Text.styles'

export const MerchSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player } = useContext(PlayerProfileContext)!
  let analytics = {
    event: 'player_jersey_click',
    params: {
      medium: `${player?.slug ? player.slug : 'Player'}_Profile`,
      slug: player?.currentTeam?.shopifyJerseyLink,
      campaign: 'player_jersey_button',
      location: 'player_profile_merch_section',
      btnText: 'Shop Now',
    },
  }
  const teamJerseyData = getTeamJerseyData(player?.currentTeam?.fullName)

  return (
    <>
      {player && teamJerseyData && (
        <Section>
          <div className="con">
              <Img src={teamJerseyData.jerseyImage} alt={`${player?.lastName ?? 'player'} jersey`} />
            <Head2 vertMargins={3}>
              {`Grab ${player?.lastName ? `${player.lastName}'s` : 'his'} Jersey`}
            </Head2>
            <LinkBtn
              href={createPlayerShopUTM({
                medium: `${player.slug}_Profile`,
                slug: teamJerseyData.jerseyLink,
                campaign: 'player_jersey_button',
              })}
              btnStyle="primary"
              analytics={analytics}
              aria-label={`Shop for ${player.firstName} ${player.lastName}`}
            >
              Shop Now
            </LinkBtn>
          </div>
        </Section>
      )}
    </>
  )
}
